import React, { createContext, useState } from "react";

export type UserInfoType = {
  postcode: string[];
  age: string[];
  id: number;
  gender?: string;
  educationLevel?: string;
  employmentStatus?: string;
  housingType?: string;
  livingSituation?: string;
};

type UserInfoProviderProps = {
  children: React.ReactNode;
};

type UserInfoContextProps = {
  userInfo: UserInfoType;
  setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
};

export const UserInfoContext = createContext<UserInfoContextProps>({
  userInfo: {
    postcode: ["", "", "", ""],
    age: ["", ""],
    id: 0,
  },
  setUserInfo: () => {},
  page: 0,
  setPage: () => {},
});

export default function UserInfoProvider({ children }: UserInfoProviderProps) {
  const [userInfo, setUserInfo] = useState({
    postcode: ["", "", "", ""],
    age: ["", ""],
    id: 0,
  } as UserInfoType);
  const [page, setPage] = useState(0);

  return (
    <UserInfoContext.Provider value={{ userInfo, setUserInfo, page, setPage }}>
      {children}
    </UserInfoContext.Provider>
  );
}
